enum IconTypes {
  archive = "archive",
  arrowDown = "arrow-down",
  arrowLeft = "arrow-left",
  arrowRight = "arrow-right",
  arrowUp = "arrowUp",
  audio = "audio",
  bell = "bell",
  bin = "bin",
  bookmark = "bookmark",
  calendar = "calendar",
  categories = "categories",
  checklist = "checklist",
  chevronDown = "chevron-down",
  chevronLeft = "chevron-left",
  chevronRight = "chevron-right",
  chevronUp = "chevron-up",
  celebration = "celebration",
  celebrationFilled = "celebration-filled",
  circleAlert = "circle-alert",
  circleAlertColor = "circle-alert-color",
  circleCancel = "circle-cancel",
  circleDisable = "circle-disable",
  circleFastForward = "circle-fast-forward",
  circleInfo = "circle-info",
  circlePlay = "circle-play",
  circleQuestion = "circle-question",
  circleTickColor = "circle-tick-color",
  compass = "compass",
  cross = "cross",
  data = "data",
  document = "document",
  dots = "dots",
  edit = "edit",
  filterOne = "filter-one",
  filterTwo = "filter-two",
  heart = "heart",
  heartFilled = "heart-filled",
  home = "home",
  homeFilled = "home-filled",
  hypnosis = "hypnosis",
  instant = "instant",
  label = "label",
  lightBulb = "light-bulb",
  location = "location",
  locationFilled = "location-filled",
  mail = "mail",
  medical = "medical",
  medicalFilled = "medicalFilled",
  meditation = "meditation",
  minus = "minus",
  notVisible = "not-visible",
  perks = "perks",
  perksFilled = "perks-filled",
  plus = "plus",
  profile = "profile",
  redeemApp = "redeemApp",
  reward = "reward",
  search = "search",
  send = "send",
  sleepStories = "sleepStories",
  settings = "settings",
  speech = "speech",
  star = "star",
  starFilled = "starFilled",
  talkingTherapy = "talkingTherapy",
  tick = "tick",
  visible = "visible",
  video = "video",
  voucher = "voucher",
  wallet = "wallet",
  wellness = "wellness",
  wellnessFilled = "wellness-filled",
  webinars = "webinars",
  workouts = "workouts",
  yoga = "yoga"
}

export default IconTypes
